export enum PickListProcessType {
    ByOrder,
    ByProduct
}